export default __webpack_public_path__ + "static/media/eyeliner.b3400b18.png";